import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CareplusAgencyService } from "src/services/careplus-agency-service";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { CareplusVerifyPaymentReq } from "src/models/careplus-payment-requests";
import { Location } from "@angular/common";

@Component({
  selector: "app-payment-verification-detail",
  templateUrl: "./payment-verification-detail.component.html",
  styleUrls: ["./payment-verification-detail.component.css"],
})
export class PaymentVerificationDetailComponent implements OnInit {
  model: CareplusVerifyPaymentReq = {
    paymentId: "",
    paymentToken: "",
  };
  id: number;
  agencyName: string = "";
  consumerReference: string = "";
  verifying: boolean = false;
  status: string = "";

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _agencyService: CareplusAgencyService,
    private _snackBar: MatSnackBar,
    private location: Location,
  ) {
    const nav = this._router.getCurrentNavigation();
    this.agencyName =
      nav?.extras?.state?.["agencyName"] || history.state?.agencyName || "-";
    this.consumerReference =
      nav?.extras?.state?.["consumerReference"] ||
      history.state?.consumerReference ||
      "-";
    this.status =
      nav?.extras?.state?.["status"] || history.state?.status || "-";
  }

  ngOnInit(): void {
    const id = this._route.snapshot.paramMap.get("id");
    if (id) {
      this.id = +id;
    }
  }

  get isPendingVerification(): boolean {
    return this.status?.trim().toUpperCase() === "PENDING_VERIFICATION";
  }

  onSubmit() {
    if (this.id) {
      this.verifying = true;
      this._agencyService.verifyPendingRequest(this.id, this.model).subscribe({
        next: () => {
          this.verifying = false;
          this._snackBar.open("Verification Successful", "Close", {
            duration: 3000,
          });
          this._router.navigate(["/careplus/payment-status-verification"]);
        },
        error: () => {
          this.verifying = false;
          this._snackBar.open("Verification Failed", "Close", {
            duration: 3000,
          });
        },
      });
    }
  }

  back() {
    this.location.back();
  }

  onBatchDetailsLoaded(res: any) {
    this.status = res?.status ?? this.status;

    if (this.status?.trim().toUpperCase() === "ISSUED") {
      this.model.paymentId = res?.paymentId ?? "";
      this.model.paymentToken = res?.paymentToken ?? "";
    }
  }
}
